import React from 'react'
import { CCard } from '@coreui/react'
import { useLanguage } from '../../../components/context/LanguageContext'
import { Tabs } from 'antd'
import { Content } from 'antd/es/layout/layout'
import AgentEmailExecution from './EmailExecution'

const AgentEmailDetails = ({ agent, refreshData }) => {

  const languageContext = useLanguage()

  return (
    <Tabs className="mt-3"
      defaultActiveKey="1"
      type="card">
      <Tabs.TabPane tab={languageContext.t('Execution')} key="1">
        <Content>
          <div>
            <AgentEmailExecution agent={agent} />
          </div>
        </Content>
      </Tabs.TabPane>
    </Tabs>
  )
}

export default AgentEmailDetails